import React from 'react'
import injectSheet from 'react-jss'

const Col = (props) => {
  const {
    classes,
    children,
    elements = 1,
  } = props

  return (
    <div
      className={`${classes.colContainer}`}
      style={{ width: `${(100 / elements)}%` }}
    >
      {children}
    </div>
  )
}

const styles = theme => ({
  colContainer: {
    padding: `0 ${(theme.sizes.gutter / 2)}px`,
  },
})

export default injectSheet(styles)(Col)



// WEBPACK FOOTER //
// ./src/modules/core/components/col.jsx